/* @flow */
import { dispatcher } from 'lib/Dispatcher';
import { ActionTypes } from 'rsvp/constants/PaymentHeaderConstants';

const PaymentHeaderActions = {
  hideNavigation(): void {
    dispatcher.dispatch({
      type: ActionTypes.HIDE_NAVIGATION,
    });
  },

  showNavigation(): void {
    dispatcher.dispatch({
      type: ActionTypes.SHOW_NAVIGATION,
    });
  },

  // this is unset by setting to null
  setEventScreenName(screenName: ?string): void {
    dispatcher.dispatch({
      type: ActionTypes.SET_EVENT_SCREEN_NAME,
      eventScreenName: screenName,
    });
  },
};

export default PaymentHeaderActions;



// WEBPACK FOOTER //
// ./src/rsvp/actions/PaymentHeaderActions.js